export function readerFindShortcut(event) {
  return (event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "f"
}

export function readerPageShortcut(event) {
  if (event.metaKey || event.ctrlKey || event.altKey || event.isComposing) return false
  if (!["ArrowLeft", "ArrowRight"].includes(event.key)) return false

  return !editableTarget(event.target)
}

function editableTarget(target) {
  return target?.isContentEditable || Boolean(target?.closest?.(
    "input, textarea, select, [contenteditable]:not([contenteditable='false'])"
  ))
}
